import { useState } from 'react';

interface QuickLogButtonProps {
  emoji: string;
  label: string;
  color: string;
  onClick: () => void;
  disabled?: boolean;
}

export function QuickLogButton({ emoji, label, color, onClick, disabled }: QuickLogButtonProps) {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleClick = () => {
    if (disabled || showSuccess) return;
    onClick();
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 1200);
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || showSuccess}
      className="flex flex-col items-center gap-1 p-3 rounded-xl transition-all active:scale-95 min-w-[72px]"
      style={{
        backgroundColor: showSuccess ? 'rgba(16, 185, 129, 0.2)' : `${color}20`,
        border: `1px solid ${showSuccess ? '#10b981' : color}40`,
      }}
    >
      <span className="text-2xl">{showSuccess ? '✓' : emoji}</span>
      <span
        className="text-[10px] font-medium"
        style={{ color: showSuccess ? '#10b981' : color }}
      >
        {showSuccess ? 'Logged!' : label}
      </span>
    </button>
  );
}
